"use strict";

define('rs/models/docstore',['rs/models/upload', 'FileAPI'], function (UploadModel, FileAPI) {
  var DocstoreModel = UploadModel.extend({
    properties: ['activityDate', 'documentId', 'fileName', 'fileType', 'id', 'updateUserAuthId', 'version', 'documentHash'],
    getRelativeURL: function getRelativeURL() {
      var id = this.getId();
      if (id != null) {
        return this.constructor.getRelativeURL(id);
      }
      throw new Error('Docstore id does not exist.  Cannot get url');
    },
    getRelativeUploadURL: function getRelativeUploadURL() {
      var id = this.getId();
      if (id != null) {
        return this.constructor.getRelativeUploadURL(id);
      }
      throw new Error('Docstore id does not exist.  Cannot get url');
    },
    getAbsoluteURL: function getAbsoluteURL() {
      var id = this.getId();
      if (id != null) {
        return this.constructor.getAbsoluteURL(id);
      }
      throw new Error('Docstore id does not exist.  Cannot get url');
    }
  }, {
    rootURI: '/rs/api/docstore',
    rootUploadURI: '/rs/api/form/docstore',
    rootImageURI: '/rs/api/form/docstore/image',
    getRelativeURL: function getRelativeURL(id, includeCsrf) {
      return this.rootURI + (id ? "/" + id : '') + (includeCsrf ? '?' + this.getCsrfParam() : '');
    },
    getRelativeUploadURL: function getRelativeUploadURL(id, includeCsrf) {
      return this.rootUploadURI + (id ? "/" + id : '') + (includeCsrf ? '?' + this.getCsrfParam() : '');
    },
    getRelativeImageURL: function getRelativeImageURL(id) {
      return this.rootImageURI + (id ? "/" + id : '');
    },
    getAbsoluteURL: function getAbsoluteURL(id, includeCsrf) {
      return window.location.protocol + "//" + window.location.host + this.getRelativeURL(id, includeCsrf);
    },
    uploadAll: function uploadAll(files, progress) {
      var i = 0;
      var len = files ? files.length : 0;
      var _upload = function upload() {
        if (i < len) {
          return this.upload(files[i++], function (pr, ev, file, xhr, options) {
            progress && progress(pr / len + i / len, ev, file, xhr, options);
          }).bind(this).tap(_upload);
        }
        return Promise.resolve();
      };
      return _upload.call(this);
    },
    upload: function upload(file, options) {
      options = options || {};
      return UploadModel.upload({
        file: file,
        progress: options.progress,
        data: options.data,
        url: DocstoreModel.getRelativeUploadURL(options.documentId)
      }).bind(this).spread(this.model);
    }
  });
  return DocstoreModel;
});

